import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    token:JSON.parse(sessionStorage.getItem('token')) ? JSON.parse(sessionStorage.getItem('token')) : false,
    user:JSON.parse(sessionStorage.getItem('user')) ? JSON.parse(sessionStorage.getItem('user')) : '',
  },
  getters: {
    token: state => state.token,
    user: state => state.user,
  },
  mutations: {
    SETToken(state, data) {
      sessionStorage.setItem('token', JSON.stringify(data));
      state.token = data
    },
    SETUser(state, data) {
      sessionStorage.setItem('user', JSON.stringify(data));
      state.user = data
    },
  },
  actions: {
    setToken({ commit }, data) {
      commit("SETToken", data)
    },
    setUser({ commit }, data) {
      commit("SETUser", data)
    }
  },
  modules: {
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js